import { RcClasses } from '../../../../foundation';
export var RcListItemTextClasses = RcClasses(['primary', 'secondary', 'inset', 'multiline'], 'RcListItemText');
